import { request } from "../utilities/request";
import apiConfig, { COMPANYID } from "../App.config";
import * as utilities from "../utilities/utils";
const axios = require('axios');

// Fetch Country data for dropdown (Country)
export function getCountry() {
  return request(
    apiConfig.BASEURL + "company/getcountry",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      countryId: -1,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// Fetch State data for dropdown (Province)
export function getState(countryId) {
  return request(
    apiConfig.BASEURL + "company/getprovince",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      stateId: -1,
      countryId: countryId,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// Fetch City data for dropdown (City) : Not currently in use
export function getCity() {
  return request(
    apiConfig.BASEURL + "location/getcity",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      cityId: -1,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// Fetch Prefered Language for dropdown (Employee’s Preferred Language) :  Not currently in use
export function getLanguage() {
  return request(
    apiConfig.BASEURL + "master/getlanguage",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      languageId: -1,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// Fetch Employment Status  :  Not currently in use
export function getEmploymentStatus() {
  return request(
    apiConfig.BASEURL + "employee/getemploymentstatus",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      employmentStatusId: -1,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// Fetch Plan Link data for dropdown (Plan Type)
export function getPlanlink(companyId) {
  return request(
    apiConfig.BASEURL + "company/getplanlinkbycompanyid",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      companyID: companyId,
      list: true,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// Fetch Location data for dropdown (Division/Location)
export function getLoction(companyId) {
  return request(
    apiConfig.BASEURL + "company/getcompanylocationbycompanyid",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      companyID: companyId,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// Fetch Region data for dropdown (Region)
export function getRegion(companyId) {
  return request(
    apiConfig.BASEURL + "company/getcompanyregionbycompanyid",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      companyID: companyId,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// Fetch Department ID for dropdown (Department ID/Cost Centre)
export function getDepartment(companyId) {
  return request(
    apiConfig.BASEURL + "company/getcompanydepartmentbycompanyid",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      companyID: companyId,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

//get region by company id
export function getRegionByCompanyId(companyId) {
  return request(
    apiConfig.BASEURL + "/company/getcompanyregionbycompanyid",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      companyID: companyId,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// Fetch Client Information list for dropdown
export function getClientInfo(companyId) {
  return request(
    apiConfig.BASEURL + "company/getclientbasicinfobycompanyid",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      companyID: companyId,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// Fetch Job title list for dropdown based on location
export function getCompanyJobs(companyid) {
  return request(
    apiConfig.BASEURL + "company/getcompanyjobs",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      companyID: companyid,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// Add New Job Detail
export function addJobDetils(jobDetails) {
  return request(
    apiConfig.BASEURL + "company/addcompanyjob",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      jobDetails: {
        ...jobDetails,
        jobID_PK: 0,
        companyID: COMPANYID,
      },
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// Download Case
export function downloadCase(ein, isAir, caseId, isPDF) {
  return axios({
    method: apiConfig.METHOD.POST,
    responseType: 'arraybuffer', //Force to receive data in a Blob Format
    url: apiConfig.BASEURL + "company/downloadCaseData",
    data: {
      companyId: 62,
      ein: ein,
      caseId: caseId,
      isPDF: isPDF,
      isAIR: isAir,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  })
    .then(res => {
      return res;
    })
    .catch(error => {
      return error;
    });
};

// Download All Case
export function downloadAllCase(ein, isAir, isPDF) {
  return axios({
    method: apiConfig.METHOD.POST,
    responseType: 'arraybuffer', //Force to receive data in a Blob Format
    url: apiConfig.BASEURL + "company/downloadCaseData",
    data: {
      companyId: 62,
      ein: ein,
      isPDF: isPDF,
      isAIR: isAir,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  })
    .then(res => {
      return res;
    })
    .catch(error => {
      return error;
    });
};


// Add New Job Detail
export function addNewManager(managerDetails) {
  return request(
    apiConfig.BASEURL + "company/addcompanysupervisor",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      supervisorInfo: {
        ...managerDetails,
        companyID_FK: COMPANYID,
      },
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// Fetch Client Info By Ein and ID for dropdown :  Not currently in use
export function getClientInfoByEinOrClientId(ein, clientId) {
  return request(
    apiConfig.BASEURL + "company/getclientinfobyeinorclientid",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      ein,
      clientId,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// Add Std Employee Form data
export function addstdemployeestatement(stdData) {
  return request(
    apiConfig.BASEURL + "employee/addstdemployeestatement",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      ...stdData,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// Upload Std Employee Form Attachments
export function uploadFiles(data) {
  return request(
    apiConfig.BASEURL + "company/uploadfile",
    apiConfig.METHOD.POST,
    {},
    data
  )
    .then((response) => {
      if (!response.errorMessage) {
        //downloadFile();
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// Remove specific Std Employee Form Attachment
export function removeFile(filePath, isDocs) {
  return request(
    apiConfig.BASEURL + "file/removefile",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      filePath,
      isDocs,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

function _base64ToArrayBuffer(base64) {
  var binary_string = window.atob(base64);
  var len = binary_string.length;
  var bytes = new Uint8Array(len);
  for (var i = 0; i < len; i++) {
    bytes[i] = binary_string.charCodeAt(i);
  }
  return bytes.buffer;
}

// Remove specific Std Employee Form Attachment
export function downloadFile(filePath) {
  let formData = new FormData();
  formData.append("filePath", "/Uploads/Docs/1071742897_ABCUserData.77ae7648.xlsx");
  formData.append("authToken", utilities.getTokenHeader().authToken);

  return request(
    apiConfig.BASEURL + "file/downlaodFile",
    apiConfig.METHOD.POST,
    // { responseType: 'blob' },
    {},
    formData
  )
    .then((response) => {
      // const linkSource = `data:${"application/octet-stream"};base64,${}`;
      // console.log(linkSource);
      // const downloadLink = document.createElement("a");
      // downloadLink.href = btoa(unescape(encodeURIComponent(response.data)));
      // downloadLink.download = "download.xlsx";
      // downloadLink.click();

      // var a = document.createElement("a");
      // document.body.appendChild(a);
      // a.style = "display: none";
      // var blob = new Blob(_base64ToArrayBuffer(btoa(unescape(encodeURIComponent(response.data))))),
      //   url = window.URL.createObjectURL(blob);
      // a.href = url;
      // a.download = "download.xlsx";
      // a.click();
      // window.URL.revokeObjectURL(url);

      const url = window.URL.createObjectURL(new Blob([new Uint8Array(response.data)], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', "download.xlsx");
      document.body.appendChild(link);
      link.click();
    })
    .catch((error) => {
      return error;
    });
}

// Fetch Supervisor list by Company Id
export function getSupervisorListByCompany(companyId) {
  return request(
    apiConfig.BASEURL + "company/getsupervisorlistbycompanyId",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      companyId: companyId,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// Fetch Manager Details by Id :  Not currently in use
export function getManagersDetails() {
  return request(
    apiConfig.BASEURL + "company/getmanagerdetails",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      managerId: 1,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// Fetch last Login details for card
export function getLastLoginInfo(profileReducer) {
  return request(
    apiConfig.BASEURL + "company/getlogininfo",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      managerId: profileReducer.managersDetails.managerId,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// Fetch Manager Total Application Count :  Not currently in use
export function getManagerTotalApplicationsCount() {
  return request(
    apiConfig.BASEURL + "company/getmanagertotalapplicationscount",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      managerId: 1,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// Fetch Attachments for table data
export function getAttachments(
  ein,
  isCustomAttachment,
  profileReducer,
  pagination
) {
  return request(
    apiConfig.BASEURL + "company/getattachments",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      managerId: profileReducer.managersDetails.managerId,
      ein,
      isCustomAttachment,
      pagination,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// Update Manager detail for profile
export function updateManagersDetails(managersDetails) {
  return request(
    apiConfig.BASEURL + "company/updatemanagerdetails",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      managersDetails,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

//Fetch data for Applicant cards
export function getEmployeebyManager(pagination, searchKey, profileReducer) {

  return request(
    apiConfig.BASEURL + "company/getstdemployeebymanager",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      managerId: profileReducer.managersDetails.managerId,
      companyId: profileReducer.managersDetails.companyId,
      pagination,
      searchKey,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

//Download all attachments in zip format
export function downloadAllAttachments(ein, isCustomAttachment, profileReducer) {
  return request(
    apiConfig.BASEURL + "company/downloadattachments",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      managerId: profileReducer.managersDetails.managerId,
      ein,
      isCustomAttachment,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

//Login verification api
export function managerLogin(loginInfo) {
  return request(
    apiConfig.BASEURL + "company/login",
    apiConfig.METHOD.POST,
    { "Content-Type": "application/json" },
    {
      loginInfo,
      header: {
        authToken: "",
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

export function updateTnCStatus(email) {
  return request(
    apiConfig.BASEURL + "company/UpdateUserConcent",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      "loginInfo": {
        "emailid": email,
      },
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

//change password  api
export function changeExpiryPassword(changePasswordInfo, authToken) {
  return request(
    apiConfig.BASEURL + "authUser/resetUserExpiredPassword",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      "userEmail": changePasswordInfo.userEmail,
      "currentPassword": changePasswordInfo.currentPassword,
      "newPassword": changePasswordInfo.newPassword,
      header: {
        "authToken": authToken,
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

//Update manager password
export function updateManagerPassword(changePassowordInfo) {
  return request(
    apiConfig.BASEURL + "company/updatemanagerpassword",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      changePassowordInfo,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

//Fetch All case detail for Cards
export function getAcmdCaseStatus(searchKey, pagination) {
  return request(
    apiConfig.BASEURL + "company/getcasestatusdetailsacmd",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      companyId: COMPANYID,
      searchKey,
      header: {
        ...utilities.getTokenHeader(),
      },
      pagination,
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

//Fetch All case detail for Cards
export function getCaseStatus(searchKey, pagination) {
  return request(
    apiConfig.BASEURL + "company/getcasestatusdetails",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      companyId: COMPANYID,
      searchKey,
      header: {
        ...utilities.getTokenHeader(),
      },
      pagination,
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

export function getAllCasesDetailsByEin(ein, pagination, profileReducer) {
  return request(
    apiConfig.BASEURL + "company/getallcasesdetailsbyein",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      ein,
      companyId: profileReducer.managersDetails.companyId,
      header: {
        ...utilities.getTokenHeader(),
      },
      pagination,
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

export function getAllActiveCases(profileReducer, searchKey) {
  return request(
    apiConfig.BASEURL + "company/getAllActiveCases",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      companyId: profileReducer.managersDetails.companyId,
      managerId: profileReducer.managersDetails.managerId,
      header: {
        ...utilities.getTokenHeader(),
      },
      searchKey: searchKey
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}


// Add Air form data
export function addAirEmployeeStatement(airData) {
  return request(
    apiConfig.BASEURL + "employee/AddAirEmployeeStatement",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      ...airData,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

//Fetch data for Air Applicant cards
export function getAirEmployeebyManager(pagination, searchKey) {
  return request(
    apiConfig.BASEURL + "company/getairemployeebymanager",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      managerId: 1,
      pagination,
      searchKey,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

//Fetch data for Search application
export function getEmployeeByFilter(searcheText, profileReducer) {
  return request(
    apiConfig.BASEURL + "company/searchemployee",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      companyId: COMPANYID,
      searcheText,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// Fetch Air Attachments for table data
export function getAirAttachments(ein, isCustomAttachment, pagination) {
  return request(
    apiConfig.BASEURL + "company/getairattachments",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      managerId: 1,
      ein,
      isCustomAttachment,
      pagination,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

//Get Accomodation Applicants
export function getAccomodationApplicants(pagination, searchKey, profileReducer) {
  return request(
    apiConfig.BASEURL + "company/getacmdemployeebymanager",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      managerId: profileReducer.managersDetails.managerId,
      searchKey,
      pagination,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// Add Accomodation form data
export function addAccomodationStatement(accomodationData) {
  return request(
    apiConfig.BASEURL + "employee/addaccommodationstatement",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      ...accomodationData,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}


// Add CCM form data
export function addCCMStatement(accomodationData) {
  return request(
    apiConfig.BASEURL + "employee/addccmstatement",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      ...accomodationData,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}


//save file treeview
export function saveTreeView(treeviewdata) {
  return request(
    apiConfig.BASEURL + "Company/uploadfileForLevelData",
    apiConfig.METHOD.POST,
    {},
    treeviewdata
    // {
    //   ,
    //   header: {
    //     ...utilities.getTokenHeader(),
    //   },
    // }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}


export function saveEmployeeData(emplyeeData) {
  return request(
    apiConfig.BASEURL + "Company/uploadfileForEmployeeData",
    apiConfig.METHOD.POST,
    {},
    emplyeeData
    // {
    //   ,
    //   header: {
    //     ...utilities.getTokenHeader(),
    //   },
    // }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// get pending Applications
export function getPendingAirApplications(managerId) {
  return request(
    apiConfig.BASEURL + "employee/getPendingAirApplications",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      header: {
        ...utilities.getTokenHeader(),
      },
      managerId: managerId
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// get All pending Applications
export function getAllPendingApplications(managerId) {
  return request(
    apiConfig.BASEURL + "employee/getAllPendingApplications",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      header: {
        ...utilities.getTokenHeader(),
      },
      managerId: managerId
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}


// get pending Applications
export function getAirEmployeeStatement(employerInformationId) {
  return request(
    apiConfig.BASEURL + "/employee/getAirEmployeeStatement",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      "employeeInformationId": employerInformationId,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}


// get Std pending Applications
export function getStdEmployeeStatement(employeeBasicInfoId) {
  return request(
    apiConfig.BASEURL + "employee/getStdEmployeeStatement",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      "employeeBasicInfoId": employeeBasicInfoId,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}


// get Accomodation pending Applications
export function getAcmdEmployeeStatement(employeeInformationId) {
  return request(
    apiConfig.BASEURL + "employee/getAcmdEmployeeStatement",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      "employeeBasicInformationId": employeeInformationId,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}


export function updateReportAccess(companyId, roleId, isAccess, reportId) {
  return request(
    apiConfig.BASEURL + "authUser/updateReportAccess",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      "companyId": companyId,
      "roleId": roleId,
      "isAccess": isAccess,
      "reportId": reportId,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

export function getReportsByCompanyId(companyId, isLangEng) {
  return request(
    apiConfig.BASEURL + "authUser/getReportsByCompanyId",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      "companyId": companyId,
      "isLangEng": isLangEng,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

export function deleteReport(companyId, reportId) {
  return request(
    apiConfig.BASEURL + "authUser/removeAssignedReport",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      "companyId": companyId,
      "reportId": reportId,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

export function downloadApplicationReport(startDate, endDate, profileReducer) {
  return request(
    apiConfig.BASEURL + "authUser/downloadApplicationsReport",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      "startDate": startDate,
      "endDate": endDate,
      "companyId": profileReducer?.managersDetails?.companyId,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}


// Get User role permissions
export function getUserRolePermissions(userRoleId) {
  return request(
    apiConfig.BASEURL + "authUser/getUserRolePermissions",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      // "userRoleId": userRoleId,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}


// Add User
export function addUser(userdata) {
  return request(
    apiConfig.BASEURL + "authUser/saveAuthUser",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      "request": userdata,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// get All Auth User Role
export function getAuthUserRoles(companyID) {
  return request(
    apiConfig.BASEURL + "authUser/getAuthUserRoles",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      "companyID": companyID,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// Add User
export function getAllAuthUsers(payload) {
  return request(
    apiConfig.BASEURL + "authUser/getAllAuthUsers",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      ...payload,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// Get Auth User By authUserId
export function getAuthUserById(authUserId) {
  return request(
    apiConfig.BASEURL + "authUser/getAuthUserById",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      "userId": authUserId,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// Get Auth User By authUserId
export function getLevelItemByLevelId(levelId, companyId) {
  return request(
    apiConfig.BASEURL + "company/getLevelItemByLevel",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      "companyId": companyId,
      "levelId": levelId,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// Delete Auth User By authUserId
export function deleteUserById(authUserId, status) {
  return request(
    apiConfig.BASEURL + "/authUser/changeUserDeleteStatus",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      "userId": authUserId,
      "status": status,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// Delete auth user termination status
export function changeTerminationStatus(authUserId, status) {
  return request(
    apiConfig.BASEURL + "/authUser/changeUserTerminateStatus",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      "userId": authUserId,
      "status": status,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// Delete auth user termination status
export function changeLockStatus(authUserId, status) {
  return request(
    apiConfig.BASEURL + "/authUser/changeUserLockStatus",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      "userId": authUserId,
      "status": status,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// change Password Api
export function changePassword(authUserId, password) {
  return request(
    apiConfig.BASEURL + "/authUser/changeUserPassword",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      "userId": authUserId,
      "password": password,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// reset Password Api
export function resetUserPassword(authUserId, password) {
  return request(
    apiConfig.BASEURL + "/authUser/resetUserPassword",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      "userId": authUserId,
      "password": password,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}


// get Company List
export function getAllCompanyList() {
  return request(
    apiConfig.BASEURL + "/company/getAllCompanies",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// get Company List
export function SaveReportAccess(data) {
  const {
    report,
    selectedCompany,
    selectedModule
  } = data;
  return request(
    apiConfig.BASEURL + "/authUser/saveReportAccess",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      header: {
        ...utilities.getTokenHeader(),
      },
      "reportId": report,
      "companyId": selectedCompany,
      "moduleId": selectedModule
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// get Company List
export function getReports(companyId, moduleId, isLangEng) {
  return request(
    apiConfig.BASEURL + "/authUser/getReports",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      "companyId": companyId,
      "moduleId": moduleId,
      "isLangEng": isLangEng,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// get Company List
export function getMyAccessReport(data) {
  return request(
    apiConfig.BASEURL + "authUser/displayReportByUser",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      ...data,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// get deparment List
export function getDepartmentByCompanyId(companyId) {
  return request(
    apiConfig.BASEURL + "/company/getcompanydepartmentbycompanyid",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      "companyID": companyId,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

//get department by region id
export function getDepartmentByRegionId(regionId) {
  return request(
    apiConfig.BASEURL + "/company/getcompanydepartmentbyregionid",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      "regionID": regionId,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// get Domain List
export function getAllDomainList(selectedCompany) {
  return request(
    apiConfig.BASEURL + "/company/getCompanyWhitelistDomains",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      companyId: selectedCompany,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// delete Domain 
export function getSelectedDomainUsers(selectedDomain) {
  return request(
    apiConfig.BASEURL + "/authUser/getUserByDomain",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      companyId: selectedDomain.companyId,
      DomainId: selectedDomain.whitelistDomainId,
      DomainName: selectedDomain.domainURL,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// get backup user List
export function getBackupUsers(regionId) {
  return request(
    apiConfig.BASEURL + "/authUser/getUsersForAuthBackup",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      regionId: regionId,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}


export function saveDomains(payload) {
  return request(
    apiConfig.BASEURL + "/company/manageCompanyDomains",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      ...payload,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

//save backup Users
export function saveBackupUser(payload) {
  return request(
    apiConfig.BASEURL + "/authUser/updateBackupUserForAuthUser",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      ...payload,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

//delete backup Users
export function deleteBackupUser(payload) {
  return request(
    apiConfig.BASEURL + "/authUser/removeUserBackupuser",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      ...payload,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}


// verify email address for password change
export function verifyEmailAddress(email) {
  return request(
    apiConfig.BASEURL + "/authUser/verifyEmailAndSendOTP",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      "email": email,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// verify email address for password change
export function verifyOtp(email, otp) {
  return request(
    apiConfig.BASEURL + "/authUser/verifyUserOTP",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      "email": email,
      "otp": otp,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}


// get Company Service
export function getCompanyServiceSettings(selectedCompany) {
  return request(
    apiConfig.BASEURL + "/company/getCompanyCFPSettings",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      companyId: selectedCompany,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

export function saveCompanyServiceSetting(payload) {
  return request(
    apiConfig.BASEURL + "/company/updateCompanyCFPSettings",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      ...payload,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// Upload Std Employee Form Attachments
export function uploadFileForUserData(data) {
  return request(
    // "http://localhost:64205/authUser/uploadfileForUserData",
    apiConfig.BASEURL + "authUser/uploadfileForUserData",
    apiConfig.METHOD.POST,
    {},
    data
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}


// get Company Service For Current user
export function getUserCompanyServices() {
  return request(
    apiConfig.BASEURL + "/company/getUserCompanyServices",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

//check if user is assignes as backup
export function checkIfUserAssignAsBackup(authUserId) {
  return request(
    apiConfig.BASEURL + "/authUser/checkIfUserAssignAsBackup",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      "userId": authUserId,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

//verify login Otp
export function verifyUserOtp(email, otp) {
  return request(
    apiConfig.BASEURL + "/authUser/verifyUserOTP",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      "email": email,
      "otp": otp,
      // header: {
      //   ...utilities.getTokenHeader(),
      // },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

//get File History
export function getFileHistory(fileLevel, companyId) {
  return request(
    apiConfig.BASEURL + "/company/getFileUploadHistory",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      "fileTypeId": fileLevel,
      "companyId": companyId,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// Delete employee statement
export function deleteEmployeeStatement(employeeInformationId, applicationType) {
  return request(
    apiConfig.BASEURL + "employee/discardPendingApplication",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      "employeeInformationId": employeeInformationId,
      "key": applicationType == "ACMD" ? "ACCM" : applicationType,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// Fetch MarqueeString
export function getNotificationMarqueeText() {
  return request(
    apiConfig.BASEURL + "/authUser/getBackupUserDetails",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// Fetch case detail by caseid
export function getAllActiveCasesByCaseId(profileReducer, caseDetail) {
  return request(
    apiConfig.BASEURL + "/company/getAllActiveCasesByCaseId",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      header: {
        ...utilities.getTokenHeader(),
      },
      "companyId": profileReducer.managersDetails.companyId,
      "managerId": profileReducer.managersDetails.managerId,
      "lang": profileReducer.managersDetails.languagePreference,
      "searchKey": "",
      "caseId": caseDetail.caseMgmtID,
      "isAIR": caseDetail.isAIR,
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// Fetch all the application which i have filled so far
export function getMyApplications(payload, pagination, companyId) {
  return request(
    apiConfig.BASEURL + "employee/getMyApplications",
    apiConfig.METHOD.POST,
    { "Content-Type": "application/json" },
    {
      ...payload,
      "companyId": companyId,
      "pagination": pagination,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// Download report file based on file id where 1 is for pdf and 2 is for excel
export function onDownloadReportClick(companyId, downloadFormat, fromDate, toDate, moduleId, reportId, levelNo, levelItemId, isLangEng) {
  return request(
    apiConfig.BASEURL + "reports/DownloadReportByReportId",
    apiConfig.METHOD.POST,
    { "Content-Type": "application/json" },
    {
      "companyId": companyId,
      "startDate": fromDate,
      "endDate": toDate,
      "reportId": reportId,
      "reportModuleId": moduleId,
      // "regionId": 0,
      // "locationId": 0,
      "downloadFormat": downloadFormat,
      "levelNo": levelNo,
      "levelItemId": levelItemId,
      "isLangEng": isLangEng,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

// This api is to load all report modules
export function getReportModule(companyId, isLangEng) {
  return request(
    apiConfig.BASEURL + "authUser/reportModule",
    apiConfig.METHOD.POST,
    { "Content-Type": "application/json" },
    {
      "companyId": companyId,
      "isLangEng": isLangEng,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

export function getCompanyAssignLevels() {
  return request(
    apiConfig.BASEURL + "company/getCompanyAssignedLevels",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}

export function getCompanyLevelsItems(levelNo) {
  return request(
    apiConfig.BASEURL + "company/getCompanyLevelItems",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      "levelNo": levelNo,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}


// get Accomodation pending Applications
export function getCCMEmployeeStatement(employeeInformationId) {
  return request(
    apiConfig.BASEURL + "employee/getCCMEmployeeStatement",
    apiConfig.METHOD.POST,
    {
      ...utilities.getTokenHeader(),
      "Content-Type": "application/json"
    },
    {
      "employeeBasicInformationId": employeeInformationId,
      header: {
        ...utilities.getTokenHeader(),
      },
    }
  )
    .then((response) => {
      if (!response.errorMessage) {
        return response;
      } else {
      }
    })
    .catch((error) => {
      return error;
    });
}